export default __webpack_public_path__ + "assets/images/MR-T2-Brain.png";